var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Input from '../Input';
import LocalizationProvider from '../LocalizationProvider';
// import useFormItemContext from '../FormItem/useFormItemContext';
import { DateIcon } from '../icons';
import { isDate, prefixZero } from '../../utils';
// export interface FbmDateRangePickerProps extends DesktopDatePickerProps {
//   value: DesktopDatePickerProps['value'];
//   onChange: DesktopDatePickerProps['onChange'];
//   inputFormat: DesktopDatePickerProps['inputFormat'];
//   disableMaskedInput: DesktopDatePickerProps['disableMaskedInput'];
//   renderInput: DesktopDatePickerProps['renderInput'];
//   error?: string | boolean;
//   InputProps?: InputProps;
// }
function useMergeProps(props) {
    // const formItemContext = useFormItemContext()
    // if (formItemContext && formItemContext.meta) {
    //   const { meta, helpers, value } = formItemContext
    //   const {
    //     onChange,
    //     error,
    //     value: valueProp,
    //     ...restProps
    //   } = props
    //   return {
    //     value,
    //     error: meta?.error,
    //     onChange: (newValue) => {
    //       if (meta.touched === false) {
    //         helpers.setTouched(true)
    //       }
    //       helpers.setValue(newValue)
    //       onChange?.(newValue)
    //     },
    //     ...restProps
    //   }
    // }
    return props;
}
// const FbmDateRangePicker: React.FC<FbmDateRangePickerProps> = props => {
var FbmDateRangePicker = function (props) {
    var _a = useMergeProps(props), label = _a.label, value = _a.value, error = _a.error, onChange = _a.onChange, onBlur = _a.onBlur, inputFormat = _a.inputFormat, DesktopDatePickerProps = __rest(_a, ["label", "value", "error", "onChange", "onBlur", "inputFormat"]);
    var inputRef = React.useRef(null);
    var handleChange = function (newValue) {
        // if (newValue === null) return
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    var renderInput = function (props) {
        var inputRefProp = props.inputRef, inputProps = props.inputProps, disabled = props.disabled, InputProps = props.InputProps;
        if (value === null) {
            inputProps.value = '';
        }
        var handleBlur = function (event) {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(value);
            if (isDate(value)) {
                var _a = inputProps.value.split('/'), yyyy = _a[0], mm = _a[1], dd = _a[2];
                var dateStr_1 = [yyyy, prefixZero(mm), prefixZero(dd)].join('/');
                setTimeout(function () {
                    inputRef.current.value = dateStr_1;
                }, 100);
            }
        };
        return (React.createElement(Input, __assign({ label: label, disabled: disabled, inputRef: inputRefProp, inputProps: __assign(__assign({}, inputProps), { ref: inputRef }) }, InputProps, { onBlur: handleBlur, onChange: function () { } })));
    };
    return (React.createElement(LocalizationProvider, null,
        React.createElement(DesktopDatePicker, __assign({ value: value, onChange: handleChange, renderInput: renderInput, disableMaskedInput: true, inputFormat: inputFormat }, DesktopDatePickerProps))));
};
FbmDateRangePicker.defaultProps = {
    inputFormat: 'yyyy/MM/dd',
    // mask: '____/__/__',
    // disableMaskedInput: true,
    components: {
        OpenPickerIcon: DateIcon,
    }
};
export default FbmDateRangePicker;
